import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
  selector: 'pcp-save-panel',
  standalone: true,
  imports: [MatButtonModule, FlexLayoutModule, MatProgressSpinner, NgIf],
  templateUrl: './save-panel.component.html',
  styleUrl: './save-panel.component.scss'
})
export class SavePanelComponent {
  @Input() disabled = false;
  @Input() saving = false;
  @Output() savingChange = new EventEmitter<boolean>();
  @Output() saveData = new EventEmitter<void>();
  @Output() resetData = new EventEmitter<void>();
  save() {
    this.savingChange.emit(true);
    this.saveData.emit();
  }
  reset() {
    this.resetData.emit();
  }
}
